/**
 * <s-preorder-countdown> — live countdown to a pre-order ship date.
 * Reads the target instant from data-target (epoch milliseconds) and updates the
 * [data-unit] cells once per second. When the date passes it shows the
 * [data-countdown-done] message and stops.
 */
class SPreorderCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.target = Number(this.dataset.target);
    if (!this.target) return;
    this.cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = this.target - Date.now();
    if (remaining <= 0) {
      clearInterval(this.#timer);
      const grid = this.querySelector('[data-countdown-grid]');
      const done = this.querySelector('[data-countdown-done]');
      if (grid) grid.hidden = true;
      if (done) done.hidden = false;
      return;
    }
    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [unit, el] of Object.entries(this.cells)) {
      if (!el) continue;
      const text = unit === 'days' ? String(values[unit]) : String(values[unit]).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }
  }
}

if (!customElements.get('s-preorder-countdown')) {
  customElements.define('s-preorder-countdown', SPreorderCountdown);
}
